import React from 'react';

export default function SortControls({
  sortBy,
  setSortBy,
  sortOrder,
  setSortOrder,
  onSortChange
}) {
  return (
    <div className="d-flex flex-shrink-0">
      <select
        className="form-select me-2"
        value={sortBy}
        onChange={(e) => { 
          setSortBy(e.target.value);
          onSortChange(1);
        }}
        style={{ width: "160px" }}
      >
        <option value="created_at">Created At</option>
        <option value="updated_at">Updated At</option>
        <option value="status">Status</option>
        <option value="first_name">First Name</option>
        <option value="last_name">Last Name</option>
        <option value="experience">Experience</option>
        <option value="location">Location</option>
        <option value="match_score">Match Score</option>
      </select>
      <select
        className="form-select"
        value={sortOrder}
        onChange={(e) => { 
          setSortOrder(e.target.value);
          onSortChange(1);
        }}
        style={{ width: "100px" }}
      >
        <option value="asc">Asc</option>
        <option value="desc">Desc</option>
      </select>
    </div>
  );
} 